module.exports = __webpack_public_path__ + "img/fond_all_in_box.570e4fa1.jpg";